"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const avModeStorageKey = "AV_Mode_Status";
function turnSwitchOn(button) {
    button.classList.add('av-mode-switch__on');
    button.classList.remove('av-mode-switch__off');
}
function turnSwitchOff(button) {
    button.classList.remove('av-mode-switch__on');
    button.classList.add('av-mode-switch__off');
}
function turnAvModeElementOn(e) {
    e.classList.add('av-mode__on');
    e.classList.remove('av-mode__off');
}
function turnAvModeElementOff(e) {
    e.classList.remove('av-mode__on');
    e.classList.add('av-mode__off');
}
function onAlwaysVisibleSwitchClick() {
    const elements = document.querySelectorAll('.av-mode');
    elements.forEach(e => {
        if (e.classList.contains('av-mode__on')) {
            turnAvModeElementOff(e);
        }
        else {
            turnAvModeElementOn(e);
        }
    });
}
document.addEventListener("DOMContentLoaded", () => {
    const buttons = document.querySelectorAll('.header__av-mode-switch');
    buttons.forEach(button => {
        if (button) {
            const isAvModeOn = sessionStorage.getItem(avModeStorageKey) === String(true);
            if (isAvModeOn) {
                turnSwitchOn(button);
                const elements = document.querySelectorAll('.av-mode');
                elements.forEach(e => {
                    if (!e.classList.contains('av-mode__on')) {
                        turnAvModeElementOn(e);
                    }
                });
            }
            button.addEventListener("click", () => {
                if (button.classList.contains('av-mode-switch__on')) {
                    sessionStorage.setItem(avModeStorageKey, String(false));
                    turnSwitchOff(button);
                }
                else {
                    sessionStorage.setItem(avModeStorageKey, String(true));
                    turnSwitchOn(button);
                }
                onAlwaysVisibleSwitchClick();
            });
        }
    });
});
